import React from 'react';
import { Lock, Heart, Sparkles, Clock, ShieldCheck } from 'lucide-react';

/**
 * SlimTrustBanner
 * Horizontal row of 5 icon+text trust cues.
 * Sits directly above the final CTA to reinforce confidence before conversion.
 */

const ITEMS = [
  { icon: Lock, label: 'Secure Deposit' },
  { icon: Heart, label: 'Personal Service' },
  { icon: Sparkles, label: '4K Quality' },
  { icon: Clock, label: 'Fast Turnaround' },
  { icon: ShieldCheck, label: 'Revisions Included' },
];

const SlimTrustBanner = () => {
  return (
    <section
      className="relative py-8 bg-black border-y border-white/10"
      data-testid="slim-trust-banner"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />

      <div className="container mx-auto px-4 lg:px-8">
        <ul className="flex flex-wrap items-center justify-center gap-x-6 sm:gap-x-10 lg:gap-x-14 gap-y-4">
          {ITEMS.map(({ icon: Icon, label }) => (
            <li key={label} className="flex items-center gap-2 text-white/85">
              <Icon size={16} className="text-amber-400" strokeWidth={1.75} />
              <span className="text-sm md:text-[15px] tracking-wide whitespace-nowrap">{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SlimTrustBanner;
